/* eslint-disable unicorn/prefer-structured-clone */
import { fillForm } from './fillForm.js';
import { getForm } from "./getForm.js";
import { updateIconNMR } from "./updateIconNMR.js";
export class ExperimentForm {
    document;
    id;
    html;
    instrument = null;
    experiments = [];
    iconNMR;
    iconNMROptions;
    onFormChange;
    constructor(document, options = {}) {
        this.document = document;
        const form = getForm(options);
        this.id = options.id ?? form.id;
        this.html = form.html;
        this.iconNMR = '';
        this.iconNMROptions = {
            user: 'defaultUser',
            name: 'defaultName',
            title: 'defaultTitle',
            holder: 0,
            solvent: 'defaultSolvent',
            deleteExistingHolder: false,
            autoSubmit: false,
        };
        updateIconNMR(this);
        this.onFormChange = (formData) => {
            this.instrument = formData.instrument;
            this.experiments = JSON.parse(JSON.stringify(formData.experiments)).filter((experiment) => experiment.enabled);
            updateIconNMR(this);
            if (options.onFormChange) {
                options.onFormChange(formData);
            }
            else {
                console.log('Form changed:', formData);
            }
        };
    }
    updateIconNMROptions(options) {
        this.iconNMROptions = options;
        updateIconNMR(this);
    }
    fillForm() {
        fillForm(this);
    }
}
//# sourceMappingURL=ExperimentForm.js.map